import { useState } from 'react'
import type { ApiNode } from '@/api/types'
import { StatusBadge } from '@/components/StatusBadge'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { NodeRemoveDialog } from './NodeRemoveDialog'

// 오프라인 노드의 상태 배지(#269). 배지 자체가 메뉴의 손잡이라 호버하면 누를 수 있는 모양이고, 메뉴에는 `노드 제거` 하나뿐이다.

export function NodeRemoveBadge({ node, name, onRemoved }: { node: ApiNode; name: string; onRemoved: () => void }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            aria-label={`${name} 상태`}
            className="max-sm:pointer-events-none cursor-pointer rounded-full transition-shadow hover:ring-2 hover:ring-danger/40 focus-visible:ring-2 focus-visible:ring-danger/60 focus-visible:outline-none"
          >
            <StatusBadge status="offline" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem variant="destructive" onSelect={() => setOpen(true)}>
            노드 제거
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <NodeRemoveDialog open={open} nodeId={node.id} name={name} onClose={() => setOpen(false)} onRemoved={onRemoved} />
    </>
  )
}
